import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-curtain-curved',
  templateUrl: './curtain-curved.component.html',
  styleUrls: ['./curtain-curved.component.scss']
})
export class CurtainCurvedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
